import { addPageAction } from './newRelicBrowser';

export function recordPdfSuccess() {
  addPageAction('PDF_SUCCESS', { value: 1 });
}

export function recordPdfFailure() {
  addPageAction('PDF_FAILURE', { value: 1 });
}

export function recordPdfDownload(startTime, length) {
  const duration = window.performance.now() - startTime;
  addPageAction('PDF_STATS', { duration, length });
}

export function recordPdfPageData(loadTime) {
  addPageAction('PDF_PAGE', { loadTime });
}

export function recordPdfPrint(type, message) {
  addPageAction('PDF_PRINT', { type, message });
}
